import React from "react";
import { Row, Col, Button, Space, Typography } from "antd";
import { v4 as uuidv4 } from "uuid";
import paymentSuccess from "../../../../assets/images/payment-success.svg";
import { getMultilingualText } from "../../../../utils/getMultilingualText";
import { useTranslation } from "react-i18next";
import db from "../../../../database";
import useCartStore from "../../../../stores/useCartStore";
import useSessionStore from "../../../../stores/useSessionStore";
import useRestaurantStore from "../../../../stores/useRestaurantStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import "../restaurantStyle.css";

const { Text } = Typography;

const OrderCompleteScreen = ({
  OrderedItem,
  currenciesList,
  multilingual,
  printReceipt,
  splitCarts,
  setShowOrderCompleteFlag,
  setPaymentVisible,
  setSelectedSaleTypeIndex,
  getDefaultSaleType,
  sortedSaleTypes,
  setSelectedSaleType,
  setSelectedSaleTypeData,
  tillData,
  userData,
  tillValue,
  setCart,
  setSplitBillScreen,
  setShowSendToKitchen,
  setSplitCarts,
  setKeyValue,
  setShowProducts,
  setTableCards,
  setOcupiedTablesData,
  setReservedTablesData,
  setTableList,
  setIsCardPaymentFlag,
  saleType,
  setNumSplits,
  setIsSplitBill,
  setCurrentSplitIndex,
}) => {
  const { t } = useTranslation();
  const [newOrderLoading, setNewOrderLoading] = React.useState(false);
  const prcPrecision = tillData?.tillAccess?.csBunit?.currencies?.[0]?.prcPrecision ?? 2;

  return (
    <div className="order-complete-root" style={{ width: "100%", height: "100vh", padding: "2vh 1vw" }}>
      <Row className="order-complete-row" gutter={[16]}>
        <Col
          className="order-complete-summary-col"
          span={12}
          style={{
            width: "100%",
            height: "96vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20vh 6vw 20vh 5vw",
            flexDirection: "column",
            fontSize: "1vw",
          }}
        >
          <div
            style={{
              fontSize: "2em",
              paddingBottom: "4vh",
              fontWeight: 600,
              color: "#0F0718",
            }}
          >
            {getMultilingualText("")} <img src={paymentSuccess} style={{ height: "4rem" }} />
          </div>
          <Space
            style={{
              width: "100%",
              justifyContent: "space-between",
              paddingTop: "2vh",
              paddingTop: "2vh",
            }}
          >
            <Text
              style={{
                fontSize: "1.5em",
                fontWeight: 400,
                color: "#0F0718",
                fontFamily: "Inter",
              }}
            >
              {getMultilingualText("Order No")}
            </Text>
            <Text
              style={{
                fontSize: "1.5em",
                fontWeight: 400,
                color: "#0F0718",
                fontFamily: "Inter",
              }}
            >
              {OrderedItem[0]?.documentno}
            </Text>
          </Space>
          <Space
            style={{
              width: "100%",
              justifyContent: "space-between",
              paddingTop: "2vh",
            }}
          >
            <Text
              style={{
                fontSize: "1.5em",
                fontWeight: 400,
                color: "#0F0718",
                fontFamily: "Inter",
              }}
            >
              {getMultilingualText("Payment Method")}
            </Text>
            <Text
              style={{
                fontSize: "1.5em",
                fontWeight: 400,
                color: "#0F0718",
                fontFamily: "Inter",
              }}
            >
              {/* {OrderedItem[0]?.payments[0]?.name} */}
              {OrderedItem[0]?.payments.map((payment, index) => (
                <span key={index}>
                  {payment.name}
                  {index < OrderedItem[0]?.payments.length - 1 && ", "}
                </span>
              ))}
            </Text>
          </Space>
          <Space
            style={{
              width: "100%",
              justifyContent: "space-between",
              paddingTop: "2vh",
            }}
          >
            <Text
              style={{
                fontSize: "1.5em",
                fontWeight: 400,
                color: "#0F0718",
                fontFamily: "Inter",
              }}
            >
              {getMultilingualText("Total Items")}
            </Text>
            <Text
              style={{
                fontSize: "1.5em",
                fontWeight: 400,
                color: "#0F0718",
                fontFamily: "Inter",
              }}
            >
              {OrderedItem[0]?.totalQty}
            </Text>
          </Space>
          <Space
            style={{
              width: "100%",
              justifyContent: "space-between",
              paddingTop: "2vh",
            }}
          >
            <Text
              style={{
                fontSize: "1.5em",
                fontWeight: 400,
                color: "#0F0718",
                fontFamily: "Inter",
              }}
            >
              {getMultilingualText("Subtotal")}
            </Text>
            <Text
              style={{
                fontSize: "1.5em",
                fontWeight: 400,
                color: "#0F0718",
                fontFamily: "Inter",
              }}
            >
              {(OrderedItem[0]?.total - OrderedItem[0]?.tax).toFixed(prcPrecision)}
            </Text>
          </Space>
          {/* <Space
            style={{
              width: "100%",
              justifyContent: "space-between",
              paddingTop: "2vh",
            }}
          >
            <Text
              style={{
                fontSize: "1.5em",
                fontWeight: 400,
                color: "#0F0718",
                fontFamily: "Inter",
              }}
            >
              Discount Sales
            </Text>
            <Text
              style={{
                fontSize: "1.5em",
                fontWeight: 400,
                color: "#0F0718",
                fontFamily: "Inter",
              }}
            >
              -4
            </Text>
          </Space> */}
          <Space
            style={{
              width: "100%",
              justifyContent: "space-between",
              paddingTop: "2vh",
            }}
          >
            <Text
              style={{
                fontSize: "1.5em",
                fontWeight: 400,
                color: "#0F0718",
                fontFamily: "Inter",
              }}
            >
              {getMultilingualText("Total Sal Tax")}
            </Text>
            <Text
              style={{
                fontSize: "1.5em",
                fontWeight: 400,
                color: "#0F0718",
                fontFamily: "Inter",
              }}
            >
              {typeof OrderedItem[0]?.tax === "number" && OrderedItem[0].tax % 1 !== 0 ? parseFloat(OrderedItem[0].tax.toFixed(prcPrecision)) : OrderedItem[0]?.tax}
            </Text>
          </Space>
          <Space
            style={{
              width: "100%",
              justifyContent: "space-between",
              paddingTop: "2vh",
            }}
          >
            <Text
              style={{
                fontSize: "1.5em",
                fontWeight: 600,
                color: "#0F0718",
                fontFamily: "Inter",
              }}
            >
              {getMultilingualText("Total Amount")}
            </Text>
            <Text
              style={{
                fontSize: "1.5em",
                fontWeight: 600,
                color: "#0F0718",
                fontFamily: "Inter",
              }}
            >
              {OrderedItem[0]?.total}
              {/* {parseFloat(OrderedItem[0]?.total - OrderedItem[0]?.discount).toFixed(2)} */}
            </Text>
          </Space>
          <Space
            style={{
              width: "100%",
              justifyContent: "space-between",
              paddingTop: "2vh",
            }}
          >
            <Text
              style={{
                fontSize: "1.5em",
                fontWeight: 600,
                color: "#0F0718",
                fontFamily: "Inter",
              }}
            >
              {getMultilingualText("Amount Paid")}
            </Text>
            <Text
              style={{
                fontSize: "1.5em",
                fontWeight: 600,
                color: "#0F0718",
                fontFamily: "Inter",
              }}
            >
              {OrderedItem[0]?.payments
                .reduce((sum, p) => sum + parseFloat(p.name.toLowerCase() === "cash" ? OrderedItem[0]?.tenderedAmount || p.amount : p.amount || 0), 0)
                .toFixed(prcPrecision)}
            </Text>
          </Space>
          <Space
            style={{
              width: "100%",
              justifyContent: "space-between",
              paddingTop: "2vh",
            }}
          >
            <Text
              style={{
                fontSize: "1.5em",
                fontWeight: 600,
                color: "#0F0718",
                fontFamily: "Inter",
              }}
            >
              {getMultilingualText("Change")}
            </Text>
            <Text
              style={{
                fontSize: "1.5em",
                fontWeight: 600,
                color: "#0F0718",
                fontFamily: "Inter",
              }}
            >
              {OrderedItem[0]?.payments.some((p) => p.name.toLowerCase() === "cash")
                ? parseFloat((OrderedItem[0]?.tenderedAmount || 0) - (OrderedItem[0]?.payments.find((p) => p.name.toLowerCase() === "cash")?.amount || 0)).toFixed(prcPrecision)
                : (0).toFixed(prcPrecision)}
            </Text>
          </Space>
        </Col>
        <Col
          className="order-complete-receipt-col"
          span={12}
          style={{
            width: "100%",
            height: "96vh",
            backgroundColor: "#fff",
            borderRadius: "15px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "1vw",
          }}
        >
          <Text
            style={{
              color: "#0F0718",
              fontSize: "1.75em",
              paddingBottom: "8vh",
              fontWeight: 500,
            }}
          >
            How would you like your receipt ?{multilingual && <div style={{ display: "block" }}>{t("How would you like your receipt ?")}</div>}
          </Text>

          <Space className="order-complete-btn-space" direction="vertical" size="large">
            <Button
              className="order-complete-btn"
              style={{
                borderRadius: "10px",
                backgroundColor: "#2F3856",
                height: "7.5vh",
                color: "#fff",
                fontSize: "1em",
                fontWeight: 500,
                width: "23vw",
              }}
              onClick={printReceipt}
            >
              {getMultilingualText("Print Receipt")}
            </Button>

            {splitCarts.length > 0 ? (
              <Button
                className="order-complete-btn"
                style={{
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  border: "1px solid #92909880",
                  height: "7.5vh",
                  color: "#2F3856",
                  fontSize: "1em",
                  fontWeight: 500,
                  width: "23vw",
                }}
                onClick={() => {
                  setShowOrderCompleteFlag(false);
                  setPaymentVisible(false);
                }}
              >
                Other Splits
              </Button>
            ) : (
              <Button
                className="order-complete-btn"
                loading={newOrderLoading}
                disabled={newOrderLoading}
                style={{
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  height: "7.5vh",
                  color: "#0F0718",
                  fontWeight: 500,
                  fontSize: "1em",
                  width: "23vw",
                }}
                onClick={async () => {
                  if (newOrderLoading) return;
                  try {
                    setNewOrderLoading(true);
                    setSelectedSaleTypeIndex(null);
                    const defaultSaleType = await getDefaultSaleType();
                    if (!defaultSaleType) {
                      console.warn("No sale type found");
                      return;
                    }
                    const defaultIndex = Array.isArray(sortedSaleTypes)
                      ? sortedSaleTypes.findIndex((st) => st?.cwrSaletype?.cwrSaletypeId === defaultSaleType?.cwrSaletype?.cwrSaletypeId)
                      : -1;

                    if (defaultIndex !== -1) {
                      setSelectedSaleTypeIndex(defaultIndex);
                    }
                    setSelectedSaleType(defaultSaleType.cwrSaletype.name);
                    setSelectedSaleTypeData(defaultSaleType);
                    usePOSConfigStore.getState().setSaleTypeData(defaultSaleType);
                    const cartData = {
                      saleType: defaultSaleType.cwrSaletype ?? {},
                      items: [],
                      couponInput: [],
                      total: 0,
                      tax: 0,
                      discount: 0,
                      paid: 0,
                      change: 0,
                      totalQty: 0,
                      roundOff: 0,
                      payments: [],
                      redemptionPoints: 0,
                      accumulationPoints: 0,
                      creditAmount: 0,
                      sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
                      referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
                      giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
                      couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
                      customer: defaultSaleType.customer?.b2cCustomerId ? defaultSaleType.customer : tillData.tillAccess.csBunit.b2cCustomer,
                      salesRepId: null,
                      cardPaymentData: {},
                      documentno: `${tillData?.tillAccess?.cwrTill?.prefix}${useSessionStore.getState().documentSequence + 1}`,
                      userName: userData?.user,
                      tillName: tillValue?.name,
                      subTotal: 0,
                      itemsSummery: {},
                      amountInWords: "",
                      groupedItemsByTaxRate: {},
                      serviceCharge: 0,
                      tip: 0,
                      deiveryCharge: 0,
                      packingCharge: 0,
                      guestName: "",
                      noOfGuests: 0,
                    };
                    setCart(cartData);
                    setSplitBillScreen(false);
                    setShowSendToKitchen(false);
                    setSplitCarts([]);
                    setNumSplits(2);
                    setIsSplitBill(false);
                    setCurrentSplitIndex(0);
                    useRestaurantStore.getState().setDineIn("Y");
                    setKeyValue("0");
                    setShowOrderCompleteFlag(false);
                    setPaymentVisible(false);
                    setShowProducts(false);
                    const type = defaultSaleType?.cwrSaletype?.fulfilmentType;
                    if (type === "TA") {
                      useRestaurantStore.getState().setDineIn("N");
                      setKeyValue("2");
                      setShowProducts(true);
                    } else if (type === "DI") {
                      useRestaurantStore.getState().setDineIn("Y");
                      setKeyValue("0");
                      const updatedTableData = await db.tableData.toArray();
                      setTableCards(updatedTableData);
                      const ocuTables = updatedTableData.filter((table) => table.statusType === "OCU" || table.statusType === "ONG");
                      setOcupiedTablesData(ocuTables);
                      const resTables = updatedTableData.filter((table) => table.statusType === "RES");
                      setReservedTablesData(resTables);
                      let tempData = [];
                      await db.tableData.toArray().then((fetched) => {
                        tempData.push(...fetched);
                      });
                      setTableList(tempData);
                    } else {
                      setIsCardPaymentFlag(false);
                      setKeyValue("1");
                    }
                  } catch (error) {
                    console.error("Error starting new order:", error);
                  } finally {
                    setNewOrderLoading(false);
                  }
                }}
              >
                {getMultilingualText("New Order")}
              </Button>
            )}

            {/* <Button
              style={{
                borderRadius: "10px",
                backgroundColor: "#fff",
                border: "1px solid #92909880",
                height: "7.5vh",
                color: "#2F3856",
                fontSize: "1em",
                fontWeight: 500,
                width: "23vw",
              }}
              onClick={() => {
                setShowOrderCompleteFlag(false);
                setPaymentVisible(false);

                if (isSplitBill) {
                  const updatedSplits = [...splitCarts];
                  updatedSplits.splice(currentSplitIndex, 1);
                  if (updatedSplits.length > 0) {
                    const regeneratedSplits = updatedSplits.map((split, index) => {
                      const sOrderID = uuidv4().replace(/-/g, "").toUpperCase();
                      return {
                        ...split,
                        payments: [],
                        isSplit: "Y",
                        sOrderID,
                        referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
                        giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
                        couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
                      };
                    });
                    setSplitCarts(regeneratedSplits);
                    setCurrentSplitIndex(0);
                    setCart(regeneratedSplits[0]);
                    setSplitBillScreen(true);
                  } else {
                    setIsSplitBill(false);
                    setSplitCarts([]);
                    setCurrentSplitIndex(0);
                    setKeyValue("0");
                  }
                }
              }}
            >
              Other Splits
            </Button> */}

            {/* <Button
              style={{
                borderRadius: "10px",
                backgroundColor: "#fff",
                height: "7.5vh",
                color: "#0F0718",
                fontWeight: 500,
                fontSize: "1em",
                width: "23vw",
              }}
              onClick={async () => {
                useRestaurantStore.getState().setDineIn("Y");
                setKeyValue("0");
                setShowOrderCompleteFlag(false);
                setPaymentVisible(false);
                setShowProducts(false);
                const cart = useCartStore.getState().cart;
                if (saleType === "TA") {
                  useRestaurantStore.getState().setDineIn("N");
                  setKeyValue("2");
                } else if (saleType === "DI") {
                  setSplitBillScreen(false);
                  setKeyValue("0");
                  const updatedTableData = await db.tableData.toArray();
                  setTableCards(updatedTableData);
                  const ocuTables = updatedTableData.filter((table) => table.statusType === "OCU");
                  setOcupiedTablesData(ocuTables);
                  const resTables = updatedTableData.filter((table) => table.statusType === "RES");
                  setReservedTablesData(resTables);
                  let tempData = [];
                  await db.tableData.toArray().then((fetched) => {
                    tempData.push(...fetched);
                  });
                  setTableList(tempData);
                } else {
                  setIsCardPaymentFlag(false);
                  setKeyValue("1");
                }
              }}
            >
              {getMultilingualText("New Order")}
            </Button> */}
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default OrderCompleteScreen;
